module.exports = __webpack_public_path__ + "img/running_btn.9ee33c87.png";